import React, { useState } from 'react';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentRichText,
} from '../../../types/KontentProps';
import RichText from '../Global/RichText';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import ShowMoreArrow from '../Global/ShowMoreArrow';
//@ts-ignore
import * as styles from './contact-us-panel.module.css';
import Jotform from '../Jotform';

type ShowTypeForm = 'show' | 'hide';
interface Props {
    primary_content: KontentStringValue;
    secondary_content: KontentRichText;
    show_or_hide_form: KontentRadioMultiChoice<ShowTypeForm>;
    contact_form: KontentStringValue;
    cta_configuration__cta_label: KontentStringValue;
}

const ContactUsPanel: React.FC<Props> = ({ ...props }) => {
    const showTypeForm = true
        ? props.show_or_hide_form.value[0]?.codename === 'show'
        : '';
    const breakpoints = useBreakpoint();
    const [innerHeight, setInnerHeight] = useState('');
    const [showLess, setShowLess] = useState(false);

    const handleShowMoreClick = () => {
        if (showLess == true) {
            setShowLess(false);
            setInnerHeight('70vh');
            //@ts-ignore
            document.getElementById('contactUsPanel').scrollIntoView();
        } else {
            setShowLess(true);
            setInnerHeight('auto');
        }
    };

    return (
        <div className={styles.wrapper} id="contactUsPanel">
            <div
                className={styles.innerContent}
                style={{ height: innerHeight }}
            >
                <div className={styles.primaryPanel}>
                    <div>{RichText(props.primary_content)}</div>

                    {showTypeForm && (
                        <div>{RichText(props.secondary_content)}</div>
                    )}
                </div>

                <div className={styles.secondaryPanel}>
                    {!showTypeForm && (
                        <div>{RichText(props.secondary_content)}</div>
                    )}

                    {showTypeForm && (
                        <div className={styles.typeform}>
                            <Jotform
                                formUrl={props.contact_form.value}
                                formStyle="embed"
                                display={true}
                            />
                        </div>
                    )}
                </div>
            </div>
            {!breakpoints.l && showLess === false && (
                <ShowMoreArrow
                    btnText="Show More"
                    strokeColor="#505251"
                    handleClick={handleShowMoreClick}
                    transform={'0'}
                />
            )}

            {!breakpoints.l && showLess === true && (
                <ShowMoreArrow
                    btnText="Show Less"
                    strokeColor="#505251"
                    handleClick={handleShowMoreClick}
                    transform={'rotate(180deg)'}
                />
            )}
        </div>
    );
};

export default ContactUsPanel;

export const fragmentContactUsPanel = graphql`
    fragment ContactUsPanel on kontent_item_component___contact_panel {
        elements {
            primary_content {
                value
            }
            secondary_content {
                value
            }
            show_or_hide_form {
                value {
                    codename
                }
            }
            contact_form {
                value
            }
        }
    }
`;
